import { missingOnboardingContactTypes } from '@/domain/ecommerce-contact'
import {
  MAX_RETURN_PERIOD_DAYS,
  isValidDayCount
} from '@/domain/return-conditions'
import { isValidIdentifier } from '@/utils'
import {
  BrandInformation,
  OnboardingUser,
  ReturnConditions,
  onboardingContacts
} from './onboarding'

export const isValidBranding = (branding: BrandInformation): boolean => {
  if (!isValidIdentifier(branding.ecommerceName)) return false
  if (branding.group && !isValidIdentifier(branding.group)) return false
  if (!branding.platform) return false
  if (!branding.contractsToUse) return false

  const canRestock =
    branding.platform === 'Shopify' ||
    branding.platform === 'Shopify Plus' ||
    branding.platform === 'Prestashop'

  if (canRestock && branding.restock === undefined) return false

  const requiresCollaboratorAccess =
    branding.platform === 'Shopify' || branding.platform === 'Shopify Plus'

  if (requiresCollaboratorAccess && !branding.shopifyCollaboratorAccess)
    return false

  if (branding.platform === 'TikTok Shop' && !isValidTiktokShopID(branding))
    return false

  return true
}

export const isValidTiktokShopID = (branding: BrandInformation): boolean => {
  if (!branding.tiktokShopId) return false

  return true
}

export const isValidReturnConditions = (
  returnConditions: ReturnConditions
): boolean => {
  if (!isValidDayCount(returnConditions.returnDays, MAX_RETURN_PERIOD_DAYS))
    return false
  if (returnConditions.refundMethods.length === 0) return false
  if (returnConditions.timing === 'NO_TIMING') return false
  if (returnConditions.returnMethods.length === 0) return false
  if (
    returnConditions.refundMethods.includes('ORIGINAL') &&
    returnConditions.fallbackBankTransfer === null
  )
    return false
  return true
}

export function isValidOnboardingUsers(users: OnboardingUser[]) {
  return (
    users.some((user) => user.role === 'admin') &&
    users.every((user) => user.contactTypes.length > 0) &&
    missingOnboardingContactTypes(onboardingContacts(users)).length === 0
  )
}
